import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
  },
  label: {
    marginTop: '10px',
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
  sortIconButton: {
    transition: 'background 0.1s',
    '&:hover': {
      background: '#F3F4F6',
    },
    borderRadius: '50%',
    padding: 4,
  },
})
